import React, { useEffect, useState } from 'react';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import shell from '../SetupWizard.module.css';
import styles from './ExampleScreens.module.css';

// Ritmo de cada linha; a última só fecha quando os exemplos já foram criados
const LINE_MS = 900;
const CLOSE_MS = 600;

/** Linhas da tela, com a área escolhida no passo 1. */
const linesFor = (areaLabel) => [
  'Lendo o que você contou: área e como você atende',
  'Montando 10 semanas de agenda nos seus horários',
  `Criando pessoas e fichas de exemplo ${areaLabel}`,
  'Lançando pagamentos de exemplo',
  'Ajustando o guia para o seu primeiro acesso',
];

/**
 * "Estamos preparando sua conta": aparece ao concluir a configuração quando
 * company/demo/seed.php (disparado ao salvar o passo 2) ainda está preenchendo a conta (docs/features/trial-demo-data, seção 3).
 * O preenchimento leva menos de dois segundos; as linhas mostram o que está sendo
 * montado com as respostas da pessoa e a última só fecha quando ele termina (ready).
 */
function PreparingScreen({ data, ready, onDone }) {
  const [active, setActive] = useState(0);
  const segment = (data.segments || []).find((item) => item.key === data.area?.segment);
  const areaLabel = segment && segment.key !== 'outra' ? `de ${segment.label}` : 'da sua área';
  const lines = linesFor(areaLabel);
  const total = lines.length;

  useEffect(() => {
    if (active > total) return undefined;
    if (active === total) {
      const timer = setTimeout(onDone, CLOSE_MS);
      return () => clearTimeout(timer);
    }
    if (active === total - 1 && !ready) return undefined;
    const timer = setTimeout(() => setActive((value) => value + 1), LINE_MS);
    return () => clearTimeout(timer);
  }, [active, ready, total, onDone]);

  return (
    <section className={`${shell.card} ${styles.preparing}`} aria-live="polite" aria-busy={active < total}>
      <span className={styles.sparkle}><AutoAwesomeOutlinedIcon /></span>
      <h1 className={shell.title}>Estamos preparando sua conta</h1>
      <p className={styles.lead}>
        Com o que você contou, a Gabriela monta uma rotina de exemplo {areaLabel} para você ver cada
        tela funcionando como se já usasse há semanas.
      </p>
      <ul className={styles.lines}>
        {lines.map((text, index) => {
          const done = index < active;
          const current = index === active;
          return (
            <li key={text} className={`${styles.line} ${current ? styles.lineActive : ''} ${done ? styles.lineDone : ''}`}>
              <span className={styles.lineMark} aria-hidden="true">
                {done && <CheckCircleIcon fontSize="small" className={styles.check} />}
                {current && <span className={styles.spinner} />}
                {!done && !current && <span className={styles.dot} />}
              </span>
              <span>{text}</span>
            </li>
          );
        })}
      </ul>
    </section>
  );
}

export default PreparingScreen;
